import styled from 'styled-components';

import { animationTime, shimmerAnimation } from './animationShimmer';

export const Container = styled.div`
  width: 29%;
  height: 80vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.white.main.hex()};
`;

export const Content = styled.div`
  width: 414px;
  min-width: 414px;
  height: 410px;
  background: ${({ theme }) => theme.palette.grey._150.hex()};
  border-radius: 13px;
  padding: 32px;
  margin-right: 25px;

  .dates {
    display: flex;
    justify-content: space-between;
  }
`;

export const ContentInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: 50%;
  padding: 6px 0;
  padding-left: 5px;
`;

export const Text2 = styled.div`
  width: 350px;
  height: 20px;
  background: ${({ theme }) => theme.palette.white.main.hex()};
  border-radius: 10px;
  margin-top: 10px;
  padding: 15px;
  animation: ${animationTime}s ${shimmerAnimation} ease-in-out infinite;
`;

export const Capacity = styled.div`
  width: 350px;
  height: 42px;
  margin-top: 10px;
  background: ${({ theme }) => theme.palette.white.main.hex()};
  border-radius: 10px;
  padding: 15px;
  animation: ${animationTime}s ${shimmerAnimation} ease-in-out infinite;
`;

export const Date = styled.div`
  width: 150px;
  height: 42px;
  margin-top: 10px;
  background: ${({ theme }) => theme.palette.white.main.hex()};
  border-radius: 10px;
  padding: 15px;
  animation: ${animationTime}s ${shimmerAnimation} ease-in-out infinite;
`;

export const AmountPaid = styled.div`
  width: 350px;
  height: 83px;
  background: ${({ theme }) => theme.palette.white.main.hex()};
  border-radius: 10px;
  padding: 15px;
  animation: ${animationTime}s ${shimmerAnimation} ease-in-out infinite;
`;

export const MissingValues = styled.div`
  width: 25%;
  height: 93px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  animation: ${animationTime}s ${shimmerAnimation} ease-in-out infinite;
  border-radius: 0 12px 12px 0;
`;
